import React, { Suspense, useState } from 'react';
import { API_URL } from '../../config';
import { Link } from 'react-router-dom';
import { Listings } from './components/Listings';
import { tabs } from '../../data/frontpage';
import { Spinner } from "../../components/common/Spinner";
import { Helmet, HelmetProvider } from 'react-helmet-async';

interface FrontpageProps {
    showLogin: boolean;
}

export const Frontpage: React.FC<FrontpageProps> = ({ showLogin }) => {
    const [activeTab] = useState<number>(0);

    if (showLogin) {

        fetch(API_URL + "profile?token=" + localStorage.getItem("token")).then((response) => {
            return response.json();
        }).then((response) => {
        }).catch(() => {
            jQuery('#loginModal').modal('show');
        })

    }

    return (
        <section className="project-area">
            <HelmetProvider>
                <Helmet>
                    <title>nfty marketplace</title>
                    <meta name="description" content="Instant, borderless real estate - nfty" />
                    <meta property="og:title" content="nfty marketplace" />
                    <meta property="og:image" content="https://nfty.property/wp-content/uploads/2023/04/h-l.webp" />
                </Helmet>
            </HelmetProvider>
            <span className="pl-bg">
                <img src="img/us-left.png" className="img-fluid" alt="" />
            </span>
            <span className="pl-rr">
                <img src="img/p-rr.png" className="img-fluid" alt="" />
            </span>
            <div className="container">
                <div className="project-menu">
                    <div className="project-m-item1">
                        <h2 style={{ color: '#FF5C00' }}>Launching Soon!</h2>
                    </div>
                    <div className="project-m-item2">
                        <ul>
                            {tabs.map((tab, index) => {
                                const linkClassName = activeTab === index ? 'active-m' : '';
                                const listClassName = index === tabs.length - 1 ? 'p-menu' : '';

                                return (
                                    <li key={tab.name} className={listClassName}>
                                        <Link to={tab.link} className={linkClassName}>
                                            {tab.name}
                                        </Link>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </div>
                <Suspense fallback={<Spinner />}>
                    <Listings />
                </Suspense>
            </div>
        </section>
    );
};